import Swal from "sweetalert2";
import {
  formatError,
  login,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp,
} from "../../services/AuthService";

export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";
export const NAVTOGGLE = "NAVTOGGLE";

export function signupAction(email, password, navigate) {
  return (dispatch) => {
    signUp(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        // runLogoutTimer(
        //   dispatch,
        //   response.data.expiresIn * 1000
        //   //history,
        // );
        dispatch(confirmedSignupAction(response.data));
        navigate("/dashboard", { replace: true });
        //history.push('/dashboard');
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function Logout(navigate) {
  localStorage.removeItem("userDetails");
  navigate("/login");

  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email, password, navigate) {
  return (dispatch) => {
    login(email, password)
      .then(async (response) => {
        console.log("response", response.data);
        if (response.data?.success) {
          const token = response.data?.data?.token;

          let data = {
            idToken: token,
            localId: response.data?.data?.user_id || "",
            role: response.data?.data?.role || "",
            name: response.data?.data?.name || "",
            email: response.data?.data?.email || "",
            refreshToken: token,
            // expireDate: new Date(new Date().getTime() + 3600 * 1000), // 1 hour from now
            // expiresIn: 3600, // or however long your backend token is valid
          };

          await saveTokenInLocalStorage(data);
          console.log("this is calling--1");
          // await runLogoutTimer(dispatch, 3600 * 1000, navigate);
          console.log("this is calling--2");
          await dispatch(loginConfirmedAction(data));
          console.log("this is calling--3");
          await navigate("/dashboard", { replace: true });
        } else {
          console.log("response", response.data?.message);
          const errorMessage = formatError(response.data?.message);
          dispatch(loginFailedAction(errorMessage));
        }
      })
      .catch((error) => {
        console.log("error", error);
        // const errorMessage = formatError(error.response.data?.message);
        // dispatch(loginFailedAction(errorMessage));
        Swal.fire({
          icon: "error",
          title: "Oops",
          text: error.response.data?.message || "Something went wrong",
        });
      });
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}
export const navtoggle = () => {
  return {
    type: "NAVTOGGLE",
  };
};
